import { createBrowserRouter } from "react-router-dom";
import { ErrorPage } from "./error";
import { SignIn } from "./containers/sign-in/sign-in";
import { App } from "./containers/app/app";
import { Users } from "./containers/app/users/users";
import { Logs } from "./containers/app/log/logs";
import { ErrorsList } from "./containers/app/errors/errors";
import { Online } from "./containers/app/online/online";
import { Files } from "./containers/app/files/files";
import { Dashboard } from "./containers/app/dashboard/dashboard";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <SignIn />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/app",
    element: <App />,
    children: [
      {
        path: "dashboard",
        element: <Dashboard />,
      },
      {
        path: "online",
        element: <Online />,
      },
      {
        path: "users",
        element: <Users />,
      },
      {
        path: "logs",
        element: <Logs />,
      },
      {
        path: "errors",
        element: <ErrorsList />,
      },
      {
        path: "files",
        element: <Files />,
      },
    ],
  },
]);
